export const getCurrentYear = (): number => {
  return new Date().getFullYear();
};

export const ORGANIZATION_NAME =
  'Idaho Association for the Education of Young Children';

export const ORGANIZATION_ADDRESS = {
  street: '1199 W Shoreline Ln #303',
  city: 'Boise',
  state: 'Idaho',
  zip: '83702',
};

export const ORGANIZATION_PHONE = '208.345.1090';

export const getCopyrightYear = (): string => {
  return `©${getCurrentYear()}`;
};

export const getFullAddress = (): string => {
  return `${ORGANIZATION_ADDRESS.street}\n${ORGANIZATION_ADDRESS.city}, ${ORGANIZATION_ADDRESS.state} ${ORGANIZATION_ADDRESS.zip}`;
};
